<template>

  <div class="home">
<!--    <router-view/>-->
    <transition  :name="transitionName" >
        <router-view  v-show="visible"></router-view>
    </transition>
    <tab-bar></tab-bar>
  </div>
</template>

<script>
// @ is an alias to /src
// import MenuBar from "../components/MenuBar";
import TabBar from "../components/CangTabBar";

export default {
  name: 'Home',
  components: {
    TabBar
  },
    data(){
        return {
            transitionName:'van-fade',
            visible:true
        }
    },
    beforeRouteUpdate (to, from, next) {
        //如果to索引大于from索引,判断为前进状态,反之则为后退状态
        if(to.meta.index > from.meta.index){
            //设置动画名称
            this.transitionName = 'van-fade';
        }else{
            this.transitionName = 'van-fade';
        }
        next()
    },
}
</script>
<style>
  .home{
    background-color:#f7f8fa;
      position: relative;
  }
</style>
